/**
 * TICTAC 2 GO — product page (2026 design).
 *
 * Mirrors the React Shop page:
 *   • gallery driven by the picked colours — combo shot first for multi-packs,
 *     then each colour's own set, then the shared shots
 *   • qty 1 → single colour picker; qty > 1 → a row per pillow (mix & match)
 *   • price row + CTA follow the selected bundle
 *   • cart adds one line per chosen colour, using the store's real variants
 */
(function () {
  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function init(root) {
    var hero = root.querySelector ? root.querySelector('[data-shop-hero]') : null;
    if (!hero) return;
    var scope = hero.closest('.shopify-section') || document;

    var urlRows = parseJSON(scope.querySelector('[data-asset-urls]'), []);
    var data = parseJSON(scope.querySelector('[data-gallery-data]'), null);
    var variants = parseJSON(scope.querySelector('[data-variant-map]'), []);
    if (!data) return;

    var urls = {};
    urlRows.forEach(function (r) { urls[r.f] = r.u; });
    var variantByColor = {};
    variants.forEach(function (v) { if (!variantByColor[v.color]) variantByColor[v.color] = v; });

    var colors = data.colors.filter(function (c) { return variantByColor[c.id]; });
    if (!colors.length) colors = data.colors;

    /* ?variant=<id> (what the footer's colour links use) or ?color=<id>
       preselects that pillow instead of defaulting to the first one. */
    function colorFromUrl() {
      var qs = new URLSearchParams(window.location.search);
      var wanted = qs.get('color');
      if (wanted) {
        for (var i = 0; i < colors.length; i++) if (colors[i].id === wanted) return wanted;
      }
      var vid = qs.get('variant');
      if (vid) {
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].id) === String(vid)) return variants[j].color;
        }
      }
      return null;
    }

    var startColor = colorFromUrl() || colors[0].id;
    var state = { qty: 1, picks: [startColor, startColor, startColor], active: 0 };

    /* ---------------- gallery ---------------- */
    function leadColor() { return state.qty === 1 ? state.picks[0] : state.picks[0]; }

    /* Mirrors Shop.jsx: a multi-pack leads with the shot of exactly that
       combination (full sorted key, then the distinct-colour key), followed by
       ONE colour's own set, the first pillow's. Stringing every chosen colour's
       set together read as one long jumble. */
    function galleryFor() {
      var picks = state.picks.slice(0, state.qty);
      var unique = picks.filter(function (v, i) { return picks.indexOf(v) === i; });
      var shots = [];
      if (state.qty > 1) {
        var full = picks.slice().sort().join('+');
        var uniq = unique.slice().sort().join('+');
        var combo = data.comboGalleries[full] || (unique.length > 1 ? data.comboGalleries[uniq] : null);
        if (combo) shots = shots.concat(combo);
      }
      shots = shots.concat(data.colorGalleries[leadColor()] || []);
      return shots.filter(function (s) { return urls[s.file]; });
    }

    /* The three clips in the buy box and the "See it in use" trio both follow
       the selected colour (pillow 1 for a pack), exactly as in Shop.jsx. */
    function clipUrl(src) { return /^https?:/.test(src) ? src : (urls[src] || ''); }
    function syncVideos() {
      var vids = (data.videosByColor || {})[leadColor()] || (data.videosByColor || {}).blue || [];
      var strip = hero.querySelector('[data-buybox-videos]');
      if (strip) {
        [].forEach.call(strip.querySelectorAll('[data-video-open]'), function (btn, i) {
          var v = vids[i]; if (!v) return;
          var url = clipUrl(v.src); if (!url) return;
          btn.setAttribute('data-src', url);
          var el = btn.querySelector('video');
          if (el) { el.poster = urls[v.poster] || ''; el.src = url; }
        });
      }
      [].forEach.call(document.querySelectorAll('[data-inuse-video]'), function (fig, i) {
        var v = vids[i]; if (!v) return;
        var url = clipUrl(v.src); if (!url) return;
        var el = fig.querySelector('video'); var cap = fig.querySelector('figcaption');
        if (el && el.getAttribute('src') !== url) {
          el.poster = urls[v.poster] || ''; el.src = url; el.load();
          if (el.getAttribute('data-in-view') === '1') { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
        }
        if (cap) cap.textContent = v.label || '';
      });
    }

    var shots = [];
    var mainImg = hero.querySelector('[data-gallery-main]');
    var thumbs = hero.querySelector('[data-gallery-thumbs]');
    var mosaic = hero.querySelector('[data-gallery-mosaic]');

    function paintGallery() {
      shots = galleryFor();
      state.active = 0;
      thumbs.innerHTML = '';
      mosaic.innerHTML = '';
      shots.forEach(function (s, i) {
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'shop__gallery-thumb' + (i === 0 ? ' is-active' : '');
        t.innerHTML = '<img src="' + urls[s.file] + '" alt="" loading="lazy" decoding="async" width="240" height="240">';
        t.addEventListener('click', function () { setActive(i); });
        thumbs.appendChild(t);

        var fig = document.createElement('figure');
        fig.className = 'shop__gallery-item shop__gallery-item--' + (i % 5 === 0 ? 'wide' : 'half');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'shop__gallery-item-btn';
        btn.setAttribute('aria-label', 'View photo ' + (i + 1) + ' of ' + shots.length + ' full screen');
        btn.innerHTML = '<img src="' + urls[s.file] + '" alt="' + (s.alt || '').replace(/"/g, '&quot;') +
                        '" loading="' + (i < 2 ? 'eager' : 'lazy') + '" decoding="async" width="1200" height="1200">';
        btn.addEventListener('click', function () { setActive(i); openBox(); });
        fig.appendChild(btn);
        mosaic.appendChild(fig);
      });
      setActive(0);
    }

    function setActive(i) {
      if (!shots.length) return;
      state.active = (i + shots.length) % shots.length;
      var s = shots[state.active];
      if (mainImg) { mainImg.src = urls[s.file]; mainImg.alt = s.alt || ''; }
      [].forEach.call(thumbs.children, function (t, n) { t.classList.toggle('is-active', n === state.active); });
    }

    /* ---------------- lightbox ---------------- */
    var box = hero.querySelector('[data-lightbox]');
    var boxImg = hero.querySelector('[data-lightbox-img]');
    var boxCount = hero.querySelector('[data-lightbox-count]');
    function paintBox() {
      var s = shots[state.active];
      if (!s) return;
      boxImg.src = urls[s.file];
      boxImg.alt = s.alt || '';
      if (boxCount) boxCount.textContent = (state.active + 1) + ' / ' + shots.length;
    }
    function openBox() { if (!box) return; paintBox(); box.hidden = false; document.body.style.overflow = 'hidden'; document.body.classList.add('tt-overlay-open'); }
    function closeBox() { if (!box) return; box.hidden = true; document.body.style.overflow = ''; document.body.classList.remove('tt-overlay-open'); }
    if (box) {
      hero.querySelector('[data-gallery-main-btn]').addEventListener('click', openBox);
      hero.querySelector('[data-lightbox-close]').addEventListener('click', closeBox);
      hero.querySelector('[data-lightbox-prev]').addEventListener('click', function (e) { e.stopPropagation(); setActive(state.active - 1); paintBox(); });
      hero.querySelector('[data-lightbox-next]').addEventListener('click', function (e) { e.stopPropagation(); setActive(state.active + 1); paintBox(); });
      box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });
      boxImg.addEventListener('click', function (e) { e.stopPropagation(); });
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') closeBox();
        if (e.key === 'ArrowLeft') { setActive(state.active - 1); paintBox(); }
        if (e.key === 'ArrowRight') { setActive(state.active + 1); paintBox(); }
      });
    }

    /* ---------------- colour pickers ---------------- */
    var singleWrap = hero.querySelector('[data-single-colors]');
    var singleSwatches = hero.querySelector('[data-single-swatches]');
    var colorName = hero.querySelector('[data-color-name]');
    var pillowWrap = hero.querySelector('[data-pillow-colors]');

    function swatchButton(colorId, selected, onPick, label) {
      var c = colors.filter(function (x) { return x.id === colorId; })[0] || colors[0];
      var b = document.createElement('button');
      b.type = 'button';
      var stock = variantByColor[c.id];
      var oos = !stock || stock.available === false;
      b.className = 'shop__swatch' + (selected ? ' is-selected' : '') + (oos ? ' is-unavailable' : '');
      if (oos) b.title = c.name + ' — sold out';
      b.style.backgroundColor = c.hex;
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', selected ? 'true' : 'false');
      b.innerHTML = '<span class="sr-only">' + c.name + '</span>';
      b.addEventListener('click', onPick);
      if (label) b.setAttribute('aria-label', label + ' ' + c.name);
      return b;
    }

    function paintColors() {
      var multi = state.qty > 1;
      singleWrap.hidden = multi;
      pillowWrap.hidden = !multi;

      if (!multi) {
        singleSwatches.innerHTML = '';
        colors.forEach(function (c) {
          singleSwatches.appendChild(swatchButton(c.id, state.picks[0] === c.id, function () {
            state.picks = [c.id, c.id, c.id];
            paintColors(); paintGallery(); syncAvailability(); syncVideos();
          }));
        });
        var cur = colors.filter(function (c) { return c.id === state.picks[0]; })[0];
        if (colorName && cur) colorName.textContent = cur.name;
        return;
      }

      pillowWrap.innerHTML = '';
      for (var i = 0; i < state.qty; i++) {
        (function (idx) {
          var row = document.createElement('div');
          row.className = 'shop__pillow-row';
          var picked = colors.filter(function (c) { return c.id === state.picks[idx]; })[0] || colors[0];
          var head = document.createElement('div');
          head.className = 'shop__pillow-row-header';
          head.innerHTML = '<span class="shop__pillow-label"><span class="shop__pillow-num">' + (idx + 1) +
                           '</span>Pillow ' + (idx + 1) + '</span>' +
                           '<span class="shop__pillow-color-name">' + picked.name + '</span>';
          var sw = document.createElement('div');
          sw.className = 'shop__swatches';
          sw.setAttribute('role', 'radiogroup');
          sw.setAttribute('aria-label', 'Color for pillow ' + (idx + 1));
          colors.forEach(function (c) {
            sw.appendChild(swatchButton(c.id, state.picks[idx] === c.id, function () {
              state.picks[idx] = c.id;
              paintColors(); paintGallery(); syncAvailability(); syncVideos(); syncVideos();
            }, 'Pillow ' + (idx + 1)));
          });
          row.appendChild(head); row.appendChild(sw);
          pillowWrap.appendChild(row);
        })(i);
      }
    }

    /* ---------------- bundles, price, cart ---------------- */
    var bundles = [].slice.call(hero.querySelectorAll('[data-bundle]'));
    var priceEl = hero.querySelector('[data-price]');
    var compareEl = hero.querySelector('[data-price-compare]');
    var badgeEl = hero.querySelector('[data-price-badge]');
    var ctaLabel = hero.querySelector('[data-cta-label]');
    var ctaBase = ctaLabel ? ctaLabel.textContent.trim() : 'Add to cart';

    var purchase = hero.querySelector('.shop__purchase');
    var soldOutLabel = (purchase && purchase.getAttribute('data-soldout-label')) || 'Sold out';
    if (purchase && purchase.getAttribute('data-cta-base')) ctaBase = purchase.getAttribute('data-cta-base');
    var currentTotal = '';

    /* Every picked colour has to be in stock — one sold-out pillow in a
       mix & match blocks the whole order, which is what the cart would do
       anyway (Shopify rejects the line with a 422). */
    function isSoldOut() {
      var picks = state.picks.slice(0, state.qty);
      for (var i = 0; i < picks.length; i++) {
        var v = variantByColor[picks[i]];
        if (!v || v.available === false) return true;
      }
      return false;
    }

    function syncAvailability() {
      var soldOut = isSoldOut();
      var addBtn = hero.querySelector('[data-add-to-cart]');
      if (addBtn) { addBtn.disabled = soldOut; addBtn.classList.toggle('is-soldout', soldOut); }
      /* Buy-now is removed entirely while sold out: a greyed-out "Buy it now"
         next to "Sold out" reads as a broken button. */
      var buyBtn = hero.querySelector('[data-buy-now]');
      if (buyBtn) { buyBtn.hidden = soldOut; buyBtn.disabled = soldOut; }
      if (ctaLabel) {
        ctaLabel.textContent = soldOut ? soldOutLabel
          : (currentTotal ? ctaBase + ' — ' + currentTotal : ctaBase);
      }
      return soldOut;
    }

    function money(str) { return (str || '').trim(); }
    function toNumber(str) {
      var n = (str || '').replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
      return parseFloat(n) || 0;
    }

    function paintPrice(btn) {
      var total = money(btn.getAttribute('data-total'));
      var compare = money(btn.getAttribute('data-compare'));
      if (priceEl) priceEl.textContent = total;
      if (compareEl) {
        compareEl.textContent = compare;
        compareEl.hidden = !compare;
      }
      if (badgeEl) {
        if (compare) {
          var off = Math.round((1 - toNumber(total) / toNumber(compare)) * 100);
          badgeEl.textContent = '−' + off + '%';
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }
      currentTotal = total;
      syncAvailability();
    }

    bundles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        bundles.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        state.qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        paintPrice(btn);
        paintColors();
        paintGallery();
      });
    });

    function cartItems() {
      var counts = {};
      state.picks.slice(0, state.qty).forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      return Object.keys(counts)
        .filter(function (id) { return variantByColor[id]; })
        .map(function (id) { return { id: variantByColor[id].id, quantity: counts[id] }; });
    }

    function addToCart(then) {
      if (isSoldOut()) return;
      var items = cartItems();
      if (!items.length) return;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { then(); })
        .catch(function () { then(); });
    }

    var addBtn = hero.querySelector('[data-add-to-cart]');
    var buyBtn = hero.querySelector('[data-buy-now]');
    if (addBtn) addBtn.addEventListener('click', function () { addToCart(function () { window.location.href = '/cart'; }); });
    if (buyBtn) buyBtn.addEventListener('click', function () { addToCart(function () { window.location.href = '/checkout'; }); });

    /* ---------------- promo videos ---------------- */
    var vModal = scope.querySelector('[data-video-modal]');
    var vPlayer = scope.querySelector('[data-video-player]');
    if (vModal && vPlayer) {
      var closeVideo = function () {
        vPlayer.pause(); vPlayer.removeAttribute('src'); vPlayer.load();
        vModal.hidden = true; document.body.style.overflow = ''; document.body.classList.remove('tt-overlay-open');
      };
      /* the clip cards live in the "See it in use" section, not the hero */
      document.querySelectorAll('[data-video-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          vPlayer.src = btn.getAttribute('data-src');
          vModal.hidden = false;
          document.body.style.overflow = 'hidden';
          document.body.classList.add('tt-overlay-open');
          var p = vPlayer.play(); if (p && p.catch) p.catch(function () {});
        });
      });
      scope.querySelector('[data-video-close]').addEventListener('click', closeVideo);
      vModal.addEventListener('click', function (e) { if (e.target === vModal) closeVideo(); });
      vPlayer.addEventListener('click', function (e) { e.stopPropagation(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !vModal.hidden) closeVideo(); });
    }

    /* ---------------- sticky mode ---------------- */
    var buybox = hero.querySelector('.shop__buybox');
    var STICKY_GAP = 19.2; /* 1.2rem, matching .shop__buybox's top in the CSS */
    function syncStickyMode() {
      if (!buybox) return;
      if (window.innerWidth < 981) { buybox.style.top = ''; return; }
      var h = buybox.offsetHeight;
      if (h + STICKY_GAP * 2 > window.innerHeight) {
        /* Taller than the viewport: pin so the panel's BOTTOM rests just above
           the fold. A negative sticky top does exactly that, and unlike
           `bottom` it still applies to an over-tall box. */
        buybox.style.top = (window.innerHeight - h - STICKY_GAP) + 'px';
      } else {
        buybox.style.top = ''; /* fits — fall back to the stylesheet's top pin */
      }
    }
    window.addEventListener('resize', syncStickyMode);

    bundles.forEach(function (btn) {
      btn.addEventListener('click', function () { setTimeout(syncStickyMode, 0); syncVideos(); });
    });

    paintColors();
    paintGallery();
    syncVideos();
    watchInuseClips();
    if (bundles.length) paintPrice(bundles[0]);
    syncStickyMode();
    /* the video posters and fonts settle after first paint — remeasure */
    window.addEventListener('load', syncStickyMode);
    setTimeout(syncStickyMode, 1200);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#chat"]');
    if (!a) return;
    var launcher = document.querySelector('.tt-chat-launcher');
    if (launcher) { e.preventDefault(); launcher.click(); }
  });

  /* "See it in use": the clips play by themselves (muted, looping) from just
     before they scroll into view, and pause again once well out of it. */
  function watchInuseClips() {
    var vids = [].slice.call(document.querySelectorAll('[data-inuse-video] video'));
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.preload = 'auto'; });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        var inView = e.isIntersecting;
        v.setAttribute('data-in-view', inView ? '1' : '0');
        if (inView) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: '130% 0px 130% 0px', threshold: 0 });   // start while still more than a screen away, so it is already running when it slides in
    vids.forEach(function (v) { io.observe(v); });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
